module.exports = __webpack_public_path__ + "img/404-clouds-2.9a0d21c6.png";